// @ts-ignore
export function lockAndAddTraitsForms(editor) {
  // helper: lock a component (and its children)
  // @ts-ignore
  const lockComponent = cmp => {
    if (!cmp) return;
    cmp.set({
      selectable: false,
      draggable: false,
      droppable: false,
      highlightable: false,
      hoverable: false,
      editable: false,
      badgable: false,
      stylable: false,
      copyable: false,
      removable: false,
    });
    // @ts-ignore
    (cmp.components?.() || []).forEach(ch => lockComponent(ch));
  };

  // Lock contents of every existing <form>
  editor
    .getWrapper()
    .find('form')
    // @ts-ignore
    .forEach(f => {
      // @ts-ignore
      (f.components?.() || []).forEach(ch => lockComponent(ch));
    });

  // Auto-select the form if something inside is selected
  // @ts-ignore
  editor.on('component:selected', cmp => {
    if (!cmp) return;
    if (cmp.is && cmp.is('form')) return;
    const formAncestor = cmp.closest && cmp.closest('form');
    if (formAncestor) editor.select(formAncestor);
  });

  // Traits (incl. Title/Description)
  const traits = [
    // Phone
    { type: 'text', name: 'ph_phone', label: 'Phone Label', changeProp: true },
    { type: 'checkbox', name: 'req_phone', label: 'Required', changeProp: true },
    { type: 'checkbox', name: 'hid_phone', label: 'Hide', changeProp: true },

    // Event Date
    { type: 'text', name: 'ph_eventDate', label: 'Event Date Label', changeProp: true },
    { type: 'checkbox', name: 'req_eventDate', label: 'Required', changeProp: true },
    { type: 'checkbox', name: 'hid_eventDate', label: 'Hide', changeProp: true },

    // Event Location
    { type: 'text', name: 'ph_eventLocation', label: 'Event Location Label', changeProp: true },
    { type: 'checkbox', name: 'req_eventLocation', label: 'Required', changeProp: true },
    { type: 'checkbox', name: 'hid_eventLocation', label: 'Hide', changeProp: true },

    // Package
    { type: 'text', name: 'ph_eventPackage', label: 'Package Label', changeProp: true },
    { type: 'checkbox', name: 'req_eventPackage', label: 'Required', changeProp: true },
    { type: 'checkbox', name: 'hid_eventPackage', label: 'Hide', changeProp: true },

    // Message
    { type: 'text', name: 'ph_message', label: 'Message Label', changeProp: true },
    { type: 'checkbox', name: 'req_message', label: 'Required', changeProp: true },
    { type: 'checkbox', name: 'hid_message', label: 'Hide', changeProp: true },
  ];
  // @ts-ignore
  const getByName = (formCmp, nm) =>
    (formCmp.find && formCmp.find(`input[name="${nm}"]`)[0]) ||
    (formCmp.find && formCmp.find(`textarea[name="${nm}"]`)[0]) ||
    null;
  // @ts-ignore
  const applyFieldBindings = (formCmp, nm, phKey, reqKey, hidKey) => {
    const fieldCmp = getByName(formCmp, nm);
    if (!fieldCmp) return;

    // prefer the wrapper .field; if not found, fall back to the field itself
    const wrapperCmp = fieldCmp.closest?.('.field') || fieldCmp;

    const setPlaceholder = () => {
      const ph = String(formCmp.get(phKey) ?? '');
      fieldCmp.addAttributes?.({ placeholder: ph, 'aria-label': ph });
    };

    const setRequired = () => {
      const req = !!formCmp.get(reqKey);
      fieldCmp.addAttributes?.(req ? { required: true } : { required: null });
    };

    const setHidden = () => {
      const hide = !!formCmp.get(hidKey);

      // reflect via attribute on wrapper
      wrapperCmp.addAttributes?.(hide ? { hidden: true } : { hidden: null });

      // and enforce via style on wrapper
      const st = { ...(wrapperCmp.getStyle?.() || {}) };
      if (hide) st.display = 'none';
      else delete st.display;
      wrapperCmp.setStyle?.(st);
    };

    // initial apply
    setPlaceholder();
    setRequired();
    setHidden();

    // watch trait changes
    formCmp.on(`change:${phKey}`, setPlaceholder);
    formCmp.on(`change:${reqKey}`, setRequired);
    formCmp.on(`change:${hidKey}`, setHidden);
  };

  // When a form is selected, show traits + wire everything
  // @ts-ignore
  editor.on('component:selected', cmp => {
    if (!cmp || !cmp.is || !cmp.is('form')) return;

    // Keep children locked
    // @ts-ignore
    (cmp.components?.() || []).forEach(ch => lockComponent(ch));

    // CHANGED: find h3 & p INSIDE the form (not on the parent)
    const titleCmp = cmp.find?.('h3')?.[0] || null; // CHANGED
    console.log('HEJ');
    const paraCmp = cmp.find?.('p')?.[0] || null; // CHANGED
    // @ts-ignore
    const setIf = (key, val) => {
      if (typeof val !== 'undefined' && val !== null) cmp.set(key, val);
    };

    // Prefill Title & Description from current content
    if (titleCmp) setIf('titleText', titleCmp.get?.('content'));
    if (paraCmp) setIf('descText', paraCmp.get?.('content'));

    // Prefill inputs
    // @ts-ignore
    const seed = (formCmp, nm, phKey, reqKey, hidKey) => {
      const f = getByName(formCmp, nm);
      if (!f) return;
      const wrapper = f.closest?.('.field') || null;

      const attrs = f.getAttributes?.() || {};
      formCmp.set(phKey, attrs.placeholder ?? '');
      formCmp.set(reqKey, !!attrs.required);

      // read hidden either from wrapper or the field’s own style/attr
      const wrapperHiddenAttr = !!wrapper?.getAttributes?.().hidden;
      const wrapperHiddenStyle = (wrapper?.getStyle?.() || {}).display === 'none';
      const fieldHiddenAttr = !!attrs.hidden;
      const fieldHiddenStyle = (f.getStyle?.() || {}).display === 'none';

      formCmp.set(hidKey, wrapperHiddenAttr || wrapperHiddenStyle || fieldHiddenAttr || fieldHiddenStyle);
    };

    seed(cmp, 'fullName', 'ph_fullName', 'req_fullName', 'hid_fullName');
    seed(cmp, 'email', 'ph_email', 'req_email', 'hid_email');
    seed(cmp, 'phone', 'ph_phone', 'req_phone', 'hid_phone');
    seed(cmp, 'eventDate', 'ph_eventDate', 'req_eventDate', 'hid_eventDate');
    seed(cmp, 'eventLocation', 'ph_eventLocation', 'req_eventLocation', 'hid_eventLocation');
    seed(cmp, 'eventPackage', 'ph_eventPackage', 'req_eventPackage', 'hid_eventPackage');
    seed(cmp, 'message', 'ph_message', 'req_message', 'hid_message');

    // Show traits
    if (typeof cmp.setTraits === 'function') cmp.setTraits(traits);
    else cmp.set && cmp.set('traits', traits);

    // CHANGED: bind Title & Description updates to the inner h3/p
    if (titleCmp) {
      cmp.off?.('change:titleText'); // avoid duplicate listeners
      cmp.on('change:titleText', () => {
        titleCmp.set?.('content', String(cmp.get('titleText') ?? '')); // CHANGED
      });
    }
    if (paraCmp) {
      cmp.off?.('change:descText');
      cmp.on('change:descText', () => {
        paraCmp.set?.('content', String(cmp.get('descText') ?? '')); // CHANGED
      });
    }

    // Bind fields
    applyFieldBindings(cmp, 'fullName', 'ph_fullName', 'req_fullName', 'hid_fullName');
    applyFieldBindings(cmp, 'email', 'ph_email', 'req_email', 'hid_email');
    applyFieldBindings(cmp, 'phone', 'ph_phone', 'req_phone', 'hid_phone');
    applyFieldBindings(cmp, 'eventDate', 'ph_eventDate', 'req_eventDate', 'hid_eventDate');
    applyFieldBindings(cmp, 'eventLocation', 'ph_eventLocation', 'req_eventLocation', 'hid_eventLocation');
    applyFieldBindings(cmp, 'eventPackage', 'ph_eventPackage', 'req_eventPackage', 'hid_eventPackage');
    applyFieldBindings(cmp, 'message', 'ph_message', 'req_message', 'hid_message');
  });
}
